import Invite from './views/Invite.vue'

const routes = [
    {
        path: '/',
        component: Invite,
        name: '',
        hidden: true,
        leaf: true, //只有一个节点
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js